import React from "react";

/**
 * props:
 * - balance: number | null
 * - currency: string (default: "₪")
 * - loading: boolean
 * - error: string | null
 * - note: string (optional) טקסט קטן מתחת ליתרה
 */
export default function WalletBalance({
  balance,
  currency = "₪",
  loading = false,
  error = null,
  note = "הסכום מתעדכן אוטומטית לפי הפעולות האחרונות",
}) {
  const isNegative = typeof balance === "number" &&  balance < 0;

  const formatMoney = (n) =>
    new Intl.NumberFormat("he-IL", {
      minimumFractionDigits: 0,
      maximumFractionDigits: 2,
    }).format(n);

  return (
    <div dir="rtl" style={styles.wrap}>
      <div style={styles.card}>
        <div style={styles.headerRow}>
          <div>
            <div style={styles.title}>יתרה בחשבון</div>
            <div style={styles.subTitle}>{note}</div>
          </div>

          <div style={styles.amountBox}>
            {loading ? (
              <div style={styles.skeleton} />
            ) : error ? (
              <div style={styles.errorText}>שגיאה בטעינת היתרה</div>
            ) : (
              <div
                style={{
                  ...styles.amount,
                  color: isNegative ? "#B42318" : "#0A7A2F",
                }}
              >
                {typeof balance === "number" ? formatMoney(balance) : "—"} {currency}
              </div>
            )}

            {!loading && !error && typeof balance === "number" && (
              <div
                style={{
                  ...styles.badge,
                  background: isNegative ? "#FEE4E2" : "#DCFCE7",
                  color: isNegative ? "#B42318" : "#0A7A2F",
                }}
              >
                {isNegative ? "ביתרת חובה" : "זמין"}
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}

const styles = {
  wrap: {
    padding: "12px 16px",
    background: "#F3F4F6",
    borderLeft: "1px solid #E5E7EB",
    borderRight: "1px solid #E5E7EB",
  },
  card: {
    background: "#FFFFFF",
    border: "1px solid #E5E7EB",
    borderRadius: 10,
    padding: "14px 16px",
    boxShadow: "0 1px 2px rgba(16,24,40,0.06)",
  },
  headerRow: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    gap: 12,
    flexWrap: "wrap",
  },
  title: {
    fontSize: 14,
    fontWeight: 700,
    color: "#0F172A",
    marginBottom: 4,
  },
  subTitle: {
    fontSize: 12,
    color: "#64748B",
  },
  amountBox: {
    display: "flex",
    alignItems: "center",
    gap: 10,
  },
  amount: {
    fontSize: 22,
    fontWeight: 800,
    letterSpacing: 0.2,
  },
  badge: {
    fontSize: 12,
    fontWeight: 700,
    padding: "6px 10px",
    borderRadius: 999,
    border: "1px solid rgba(0,0,0,0.06)",
    whiteSpace: "nowrap",
  },
  skeleton: {
    width: 140,
    height: 26,
    borderRadius: 8,
    background:
      "linear-gradient(90deg, #E5E7EB 0%, #F3F4F6 40%, #E5E7EB 80%)",
    backgroundSize: "200% 100%",
    animation: "shimmer 1.2s infinite",
  },
  errorText: {
    fontSize: 13,
    fontWeight: 700,
    color: "#B42318",
  },
};
